var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 49,
    viewBox: "0 0 22 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.09812 0.5L21.6602 7.58705V41.4129L6.09812 48.5L0.339844 45.0894V3.91064L6.09812 0.5ZM5.27129 2.95094L3.17469 4.19117L5.27129 4.94417V2.95094ZM5.27129 6.7307L2.09685 5.57905V43.4209L5.27129 42.2693V6.7307ZM7.0283 41.6344V7.36558L14.8979 10.2152V38.7848L7.0283 41.6344ZM5.27129 44.0558L3.17469 44.8088L5.27129 46.0491V44.0558ZM7.0283 46.241V43.4209L15.7986 40.2465L18.4267 41.0586L7.0283 46.2558V46.241ZM19.9032 39.7593L16.6549 38.7553V10.2595L19.9032 9.27022V39.7593ZM18.4267 7.97093L15.7986 8.76822L7.0283 5.59382V2.77376L18.412 7.95617L18.4267 7.97093Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b61f72e205d27cfd3ca4792a8d3801b4.svg";
export { ForwardRef as ReactComponent };